import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
`;

export const DemandaColumn = styled.div`
  width: 16%;
  margin-right: 32px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  text-align: start;
`;

export const Header = styled.div``;

export const Field = styled.div``;
